export default __webpack_public_path__ + "347f419da482e6e39c854328fa78ef76.svg";